import { render, staticRenderFns } from "./game-rating.vue?vue&type=template&id=48251da3&"
import script from "./game-rating.vue?vue&type=script&lang=js&"
export * from "./game-rating.vue?vue&type=script&lang=js&"
import style0 from "./game-rating.vue?vue&type=style&index=0&id=48251da3&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports